export const updateNodesUserCount = ({ id, nodes }) => {
  const updateNodes = nodes.map((node) => {
    if (node.id === id) {
      return { ...node, userConnected: 0 };
    }
    return node;
  });
  return updateNodes;
};
